import loadable from '@loadable/component';

export const namespace = 'canalplus.block.smartfaq';
export const Component = loadable(() => import('./containers/FAQContainer'));
export { default as propsFormatter } from './propsFormatter';
